export const VIEW_BLOG = 'VIEW_BLOG';
export const ERROR_VIEWING_BLOG = 'ERROR_VIEWING_BLOG';
export const BEFORE_VIEW_BLOG = 'BEFORE_VIEW_BLOG';